import { useId } from 'react';

import { cn } from '@kit/ui/utils';

/** Union Jack, 2:1. Size and border come from `className`. */
export function UkFlag({ className }: { className?: string }) {
  const clipId = useId();

  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 60 30"
      className={cn('shrink-0 rounded-[2px]', className)}
    >
      <clipPath id={clipId}>
        <path d="M30,15 h30 v15 z v15 h-30 z h-30 v-15 z v-15 h30 z" />
      </clipPath>
      <path d="M0,0 v30 h60 v-30 z" fill="#012169" />
      <path d="M0,0 L60,30 M60,0 L0,30" stroke="#fff" strokeWidth="6" />
      <path
        d="M0,0 L60,30 M60,0 L0,30"
        clipPath={`url(#${clipId})`}
        stroke="#C8102E"
        strokeWidth="4"
      />
      <path d="M30,0 v30 M0,15 h60" stroke="#fff" strokeWidth="10" />
      <path d="M30,0 v30 M0,15 h60" stroke="#C8102E" strokeWidth="6" />
    </svg>
  );
}

/** Polish flag, 16:10. Size and border come from `className`. */
export function PlFlag({ className }: { className?: string }) {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 16 10"
      className={cn('shrink-0 rounded-[2px]', className)}
    >
      <rect width="16" height="5" fill="#fff" />
      <rect y="5" width="16" height="5" fill="#dc143c" />
    </svg>
  );
}
